var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'hidden':_vm.show,'heightauto':!_vm.show},attrs:{"id":"app"}},[_c('a-spin',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }